import { AutocompleteService } from '@shared/services/autocomplete.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DatepickerService } from '@shared/services/datepicker.service';
import { JalaliService } from './services/datepicker.service';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import * as moment from 'jalali-moment';

import {
 ChangeDetectionStrategy,
 ChangeDetectorRef,
 Component,
 effect,
 ElementRef,
 EventEmitter,
 HostListener,
 Inject,
 inject,
 Input,
 OnInit,
 Output,
 PLATFORM_ID,
 QueryList,
 signal,
 ViewChildren,
} from '@angular/core';
import { SearchBoxService } from '@shared/services/serach-box.service';
@Component({
 selector: 'iho-datepicker',
 templateUrl: './datepicker.component.html',
 styleUrls: ['./datepicker.component.scss'],
 standalone: true,
 changeDetection: ChangeDetectionStrategy.OnPush,
 imports: [
  CommonModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatFormFieldModule,
  MatInputModule,
  MatTabsModule,
 ],
})
export class DatepickerComponent implements OnInit {
 @ViewChildren('cell') cell!: QueryList<ElementRef>;
 @ViewChildren('cellInput') cellInput!: QueryList<ElementRef>;

 @Input() searchOnConfirm = false;
 @Output() triggerSearch: EventEmitter<boolean> = new EventEmitter(false);

 autocompleteService = inject(AutocompleteService);
 searchBoxService = inject(SearchBoxService);
 cdr = inject(ChangeDetectorRef);
 datepickerService = inject(DatepickerService);
 reservable: boolean = false;
 csrStatus = signal<boolean>(false);

 customEndDate = '';
 customStartDate = '';
 datepickerPack: any = [];
 datepickerVisibility = [false, false, true, true, true, true, true, true, true, true, true, true];
 desktopToggle: number[] = [0, 1];
 duration: string[] = [];
 endDate = '';
 gregorianToday = moment().format('YYYY/MM/DD');
 initialCounter = 0;
 jalaliToday = moment().locale('fa').format('YYYY/MM/DD');
 notAllowCursorNextMonth = false;
 notAllowCursorPrevMonth = true;
 startDate = '';
 tip = '';

 constructor(
  private JalaliService: JalaliService,
  @Inject(PLATFORM_ID) private platformId: Record<string, string>
 ) {
  if (isPlatformBrowser(this.platformId)) {
   this.csrStatus.set(true);
  }

  effect(
   () => {
    if (this.datepickerService._endDate()) {
     this.setInitialDate();
    }
   },
   { allowSignalWrites: true }
  );
 }

 jalaliCalendar(sectionNumber: number) {
  const monthArray = [
   '',
   'فروردین',
   'اردیبهشت',
   'خرداد',
   'تیر',
   'مرداد',
   'شهریور',
   'مهر',
   'آبان',
   'آذر',
   'دی',
   'بهمن',
   'اسفند',
  ];
  const jalaliDate = moment()
   .locale('fa')
   .add(0 + sectionNumber, 'month')
   .format('YYYY/MM/DD');
  const jalaliDateArray = jalaliDate.split('/');
  const jalaliYear = jalaliDateArray[0];
  const jalaliMonth = jalaliDateArray[1];
  const jalalitDay = 1;
  const daysOfMonth = this.JalaliService.daysOfMonth(+jalaliMonth, +jalaliYear);
  const gregorianDateArray = this.JalaliService.convertToGregorian(
   +jalaliYear,
   +jalaliMonth,
   jalalitDay
  );
  const gregorianDate = `${gregorianDateArray[0]}/${('0' + gregorianDateArray[1]).slice(-2)}/${(
   '0' + gregorianDateArray[2]
  ).slice(-2)}`;
  const gregorianFullDate = moment(gregorianDate).locale('en').format('dddd');
  this.datepickerPack.push({
   sectionYear: +jalaliYear,
   sectionMonth: +jalaliMonth,
   sectionMonthTitle: monthArray[+jalaliMonth],
   sectionDaysOfMonthArray: Array(
    daysOfMonth + this.JalaliService.firstDayOfMonth(gregorianFullDate)
   ).fill(0),
   sectionFirstDay: this.JalaliService.firstDayOfMonth(gregorianFullDate),
  });
 }

 gregorianCalendar(sectionNumber: number) {
  const monthArray = [
   '',
   'ژانویه',
   'فوریه',
   'مارس',
   'آپریل',
   'مه',
   'ژوئن',
   'جولای',
   'آگوست',
   'سپتامبر',
   'اکتبر',
   'نوامبر',
   'دسامبر',
  ];
  const todayHelper = new Date(
   new Date().getFullYear(),
   new Date().getMonth() + sectionNumber,
   new Date().getDate()
  ).toLocaleDateString('en-GB', { dateStyle: 'short', numberingSystem: 'latn' });
  const today = `${todayHelper.split('/')[2]}/${todayHelper.split('/')[1]}/${
   todayHelper.split('/')[0]
  }`;
  const todayArray = today.split('/');
  const gregorianYear = todayArray[0];
  const gregorianMonth = todayArray[1];
  const gregorianFullDate = new Date(
   `${todayHelper.split('/')[2]}/${todayHelper.split('/')[1]}/1`
  ).toLocaleDateString('en-GB', { dateStyle: 'full', numberingSystem: 'latn' });
  this.datepickerPack.push({
   sectionYear: +gregorianYear,
   sectionMonth: +gregorianMonth,
   sectionMonthTitle: monthArray[+gregorianMonth],
   sectionDaysOfMonthArray: Array(new Date(+gregorianYear, +gregorianMonth, 0).getDate()).fill(0),
   sectionFirstDay: this.JalaliService.firstDayOfMonth(gregorianFullDate),
  });
 }

 changeLocate(locale: string) {
  // will be back soon (new way)
 }

 navigateMonth(type: string) {
  if (type === 'next') {
   if (this.initialCounter <= 10) {
    this.notAllowCursorNextMonth = false;
    this.notAllowCursorPrevMonth = false;
    this.datepickerPack = [];
    if (this.datepickerService._locale() === 'fa') {
     this.jalaliCalendar(this.initialCounter);
     this.initialCounter = this.initialCounter + 1;
     this.jalaliCalendar(this.initialCounter);
    }
    if (this.datepickerService._locale() === 'en') {
     this.gregorianCalendar(this.initialCounter);
     this.initialCounter = this.initialCounter + 1;
     this.gregorianCalendar(this.initialCounter);
    }
   }
   if (this.initialCounter > 10) {
    this.notAllowCursorNextMonth = true;
   }
  }
  if (type === 'previous') {
   if (this.initialCounter >= 2) {
    this.notAllowCursorPrevMonth = false;
    this.notAllowCursorNextMonth = false;
    this.datepickerPack = [];
    if (this.datepickerService._locale() === 'fa') {
     this.initialCounter = this.initialCounter - 2;
     this.jalaliCalendar(this.initialCounter);
     this.initialCounter = this.initialCounter + 1;
     this.jalaliCalendar(this.initialCounter);
    }
    if (this.datepickerService._locale() === 'en') {
     this.initialCounter = this.initialCounter - 2;
     this.gregorianCalendar(this.initialCounter);
     this.initialCounter = this.initialCounter + 1;
     this.gregorianCalendar(this.initialCounter);
    }
   }
   if (this.initialCounter < 2) {
    this.notAllowCursorPrevMonth = true;
   }
  }
  this.reArrangeDate();
 }

 reArrangeDate() {
  if (isPlatformBrowser(this.platformId)) {
   setTimeout(() => {
    this.cell?.toArray().forEach((obj) => {
     obj.nativeElement.classList.remove('start-date');
     obj.nativeElement.classList.remove('end-date');
     obj.nativeElement.classList.remove('duration');
    });
    const startDateArray = this.datepickerService._startDate().split('/');
    const startDateHelper = `${startDateArray[0]}/${('0' + startDateArray[1]).slice(-2)}/${(
     '0' + startDateArray[2]
    ).slice(-2)}`;
    const endDateArray = this.datepickerService._endDate().split('/');
    const endDateHelper = `${endDateArray[0]}/${('0' + endDateArray[1]).slice(-2)}/${(
     '0' + endDateArray[2]
    ).slice(-2)}`;
    this.cellInput.toArray().forEach((obj) => {
     const cellDateHelper = `${obj.nativeElement.value.split('/')[0]}/${(
      '0' + obj.nativeElement.value.split('/')[1]
     ).slice(-2)}/${('0' + obj.nativeElement.value.split('/')[2]).slice(-2)}`;
     if (startDateHelper === cellDateHelper) {
      obj.nativeElement.closest('.cell').classList.add('start-date');
     }
     if (endDateHelper === cellDateHelper) {
      obj.nativeElement.closest('.cell').classList.add('end-date');
     }
     if (startDateHelper <= cellDateHelper && endDateHelper >= cellDateHelper) {
      obj.nativeElement.closest('.cell').classList.add('duration');
     }
    });
   });
  }
 }

 reset() {
  this.cell.toArray().forEach((obj) => {
   obj.nativeElement.classList.remove('start-date');
   obj.nativeElement.classList.remove('end-date');
   obj.nativeElement.classList.remove('duration');
  });
  this.endDate = '';
  this.customEndDate = '';
  this.startDate = '';
  this.customStartDate = '';
  this.notAllowCursorNextMonth = false;
  this.notAllowCursorPrevMonth = true;
  this.desktopToggle = [0, 1];
  this.datepickerService.setStartDate('');
  this.datepickerService.setCustomStartDate('');
  this.datepickerService.setEndDate('');
  this.datepickerService.setCustomEndDate('');
  this.datepickerPack = [];
  this.duration = [];
  this.initialCounter = 0;
  if (this.datepickerService._locale() === 'fa') {
   this.jalaliCalendar(this.initialCounter);
   this.jalaliCalendar(this.initialCounter + 1);
   this.initialCounter = 1;
  }
  if (this.datepickerService._locale() === 'en') {
   this.gregorianCalendar(this.initialCounter);
   this.gregorianCalendar(this.initialCounter + 1);
   this.initialCounter = 1;
  }
 }

 isDisable(year: number, month: number, day: number): boolean {
  let minDate = '';
  if (this.datepickerService._locale() === 'fa') {
   let minDateHelper = this.datepickerService._minDate();
   minDate = `${minDateHelper.split('/')[0]}/${('0' + minDateHelper.split('/')[1]).slice(-2)}/${(
    '0' + minDateHelper.split('/')[2]
   ).slice(-2)}`;
  }
  if (this.datepickerService._locale() === 'en') {
   let minDateHelper = this.JalaliService.convertToGregorian(
    +this.datepickerService._minDate().split('/')[0],
    +this.datepickerService._minDate().split('/')[1],
    +this.datepickerService._minDate().split('/')[2]
   );
   minDate = `${minDateHelper[0]}/${('0' + minDateHelper[1]).slice(-2)}/${(
    '0' + minDateHelper[2]
   ).slice(-2)}`;
  }
  const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
  const maxDateArray = this.datepickerService._minDate().split('/');
  const maxDateString = `${maxDateArray[0]}/${('0' + maxDateArray[1]).slice(-2)}/${(
   '0' + maxDateArray[2]
  ).slice(-2)}`;
  let result = true;
  if (this.datepickerService._minDate() === '' && this.datepickerService._maxDate() === '') {
   this.datepickerService._disable().forEach((obj: any) => {
    if (cellDate === obj) {
     result = false;
    }
   });
  }
  if (this.datepickerService._minDate() !== '' && cellDate < minDate) {
   result = false;
  }
  if (this.datepickerService._maxDate() !== '' && cellDate > maxDateString) {
   result = false;
  }
  return result;
 }

 isUnreservable(year: number, month: number, day: number): number {
  let result = 0;
  if (this.datepickerService._unReservable().length !== 0) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   this.datepickerService._unReservable().forEach((obj: any) => {
    const cellHelper = `${obj.split(',')[0].split('/')[0]}/${(
     0 + obj.split(',')[0].split('/')[1].toString()
    ).slice(-2)}/${(0 + obj.split(',')[0].split('/')[2].toString()).slice(-2)}`;
    if (cellDate === cellHelper && +obj.split(',')[1] === 2) {
     result = 1;
    }
    if (cellDate === cellHelper && +obj.split(',')[1] === 3) {
     result = 3;
    }
    if (cellDate === cellHelper && +obj.split(',')[1] === 4) {
     result = 4;
    }
   });
  }
  return result;
 }

 isHoliday(year: number, month: number, day: number): boolean {
  let result = false;
  if (this.datepickerService._holidays()) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   this.datepickerService._holidays().forEach((obj: any) => {
    if (cellDate === obj.PersianDate) {
     result = true;
    }
   });
  }
  return result;
 }

 hasPrice(year: number, month: number, day: number): string {
  let result = '0';
  if (this.datepickerService._price().length !== 0) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   this.datepickerService._price().forEach((obj: any) => {
    if (cellDate === obj.date) {
     result = obj.amount.toLocaleString();
    }
   });
  }
  return result;
 }

 hasWeather(year: number, month: number, day: number): string {
  let result = '0';
  if (this.datepickerService._weather().length !== 0) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   this.datepickerService._weather().forEach((obj: any) => {
    if (cellDate === obj.date) {
     result = obj.forcast;
    }
   });
  }
  return result;
 }

 selectDate(year: number, month: number, day: number, event: any) {
  let monthArray: string[] = [];
  if (this.datepickerService._locale() === 'fa') {
   monthArray = [
    '',
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
   ];
  }
  if (this.datepickerService._locale() === 'en') {
   monthArray = [
    '',
    'ژانویه',
    'فوریه',
    'مارس',
    'آپریل',
    'مه',
    'ژوئن',
    'جولای',
    'آگوست',
    'سپتامبر',
    'اکتبر',
    'نوامبر',
    'دسامبر',
   ];
  }
  const cellDate = `${year}/${month}/${day}`;
  const cellDateHelper = `${year}/${(0 + month.toString()).slice(-2)}/${(0 + day.toString()).slice(
   -2
  )}`;
  const restriction = this.isUnreservable(year, month, day);
  const selectedStartDate = this.normalizeCalendarDate(this.startDate);
  const selectedEndDate = this.normalizeCalendarDate(this.endDate);
  const cell = event.currentTarget as HTMLElement;

  if (cellDateHelper === selectedStartDate) {
   this.clearDateSelection();
   return;
  }
  if (cellDateHelper === selectedEndDate) {
   this.clearEndDateSelection();
   return;
  }
  if (!this.isDisable(year, month, day) || restriction === 1) {
   return;
  }

  this.cell.toArray().forEach((obj) => obj.nativeElement.classList.remove('duration'));
  this.duration = [];
  this.datepickerService.setSelectedNights([]);

  if (this.startDate !== '' && this.endDate !== '') {
   this.clearDateSelection();
  }

  if (this.startDate === '') {
   // Status 3 means check-in is restricted. It can only be selected as a check-out date.
   if (restriction === 3) return;

   this.startDate = cellDate;
   this.customStartDate = `${cellDate.split('/')[2]} ${monthArray[+cellDate.split('/')[1]]}`;
   this.datepickerService.setStartDate(cellDate);
   this.datepickerService.setCustomStartDate(this.customStartDate);
   this.endDate = '';
   this.datepickerService.setEndDate('');
   this.datepickerService.setCustomEndDate('');
   cell.classList.add('start-date');
  } else if (this.endDate === '') {
   // Status 4 means check-out is restricted. It can only be selected as a check-in date.
   if (restriction === 4) return;

   const startDateHelper = this.normalizeCalendarDate(this.startDate);
   if (cellDateHelper <= startDateHelper) {
    // An earlier date replaces the current check-in, so check-in restrictions apply here too.
    if (restriction === 3) return;

    this.cell.toArray().forEach((obj) => obj.nativeElement.classList.remove('start-date'));
    this.startDate = cellDate;
    this.customStartDate = `${cellDate.split('/')[2]} ${monthArray[+cellDate.split('/')[1]]}`;
    this.datepickerService.setStartDate(cellDate);
    this.datepickerService.setCustomStartDate(this.customStartDate);
    this.endDate = '';
    this.datepickerService.setEndDate('');
    this.datepickerService.setCustomEndDate('');
    cell.classList.add('start-date');
   } else {
    this.endDate = cellDate;
    this.customEndDate = `${cellDate.split('/')[2]} ${monthArray[+cellDate.split('/')[1]]}`;
    this.setDuration();
    this.datepickerService.setEndDate(this.endDate);
    this.datepickerService.setCustomEndDate(this.customEndDate);
    cell.classList.add('end-date');
    const endDateHelper = this.normalizeCalendarDate(this.endDate);
    this.cellInput.toArray().forEach((obj) => {
     const currentCellDate = this.normalizeCalendarDate(obj.nativeElement.value);
     if (startDateHelper <= currentCellDate && endDateHelper >= currentCellDate) {
      obj.nativeElement.closest('.cell').classList.add('duration');
     }
    });
   }
  }
 }

 private normalizeCalendarDate(date: string): string {
  if (!date) return '';
  const [year, month, day] = date.split('/');
  return `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`;
 }

 private clearEndDateSelection(): void {
  this.endDate = '';
  this.customEndDate = '';
  this.duration = [];
  this.datepickerService.setEndDate('');
  this.datepickerService.setCustomEndDate('');
  this.datepickerService.setSelectedDate([]);
  this.datepickerService.setSelectedNights([]);
  this.cell.toArray().forEach((obj) => {
   obj.nativeElement.classList.remove('end-date');
   obj.nativeElement.classList.remove('duration');
  });
 }

 private clearDateSelection(): void {
  this.startDate = '';
  this.customStartDate = '';
  this.clearEndDateSelection();
  this.datepickerService.setStartDate('');
  this.datepickerService.setCustomStartDate('');
  this.cell.toArray().forEach((obj) => obj.nativeElement.classList.remove('start-date'));
 }

    setDuration() {
        this.duration = [];

        const [sy, sm, sd] = this.startDate.split('/').map(Number);
        const [ey, em, ed] = this.endDate.split('/').map(Number);

        let currentYear = sy;
        let currentMonth = sm;
        let currentDay = sd;

        while (
            currentYear < ey ||
            (currentYear === ey && currentMonth < em) ||
            (currentYear === ey && currentMonth === em && currentDay <= ed)
        ) {
            this.duration.push(`${currentYear}/${currentMonth}/${currentDay}`);

            const daysInMonth = this.JalaliService.daysOfMonth(currentMonth, currentYear);
            currentDay++;

            if (currentDay > daysInMonth) {
                currentDay = 1;
                currentMonth++;
                if (currentMonth > 12) {
                    currentMonth = 1;
                    currentYear++;
                }
            }
        }

        this.datepickerService.setSelectedNights(this.duration);
    }

 submitDate() {
  this.datepickerService.reservable.set(false);
  this.datepickerService.setState(false);
  if (this.datepickerService._allowToShow()) {
   this.datepickerService.setSelectedDate(this.duration);
   this.datepickerService.setStartDate(this.startDate);
   this.datepickerService.setEndDate(this.endDate);

   if (this.autocompleteService._selectedItem().id === undefined) {
    setTimeout(() => {
     this.autocompleteService.setState('favorite');
    });
   }
  }
  if (!this.datepickerService._allowToShow() || this.searchOnConfirm) {
   this.triggerSearch.emit(true);
  }
 }

 setTooltip(year: number, month: number, day: number) {
  if (this.datepickerService._unReservable().length === 0) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   let result = '';
   if (this.datepickerService._holidays()) {
    this.datepickerService._holidays().forEach((obj: any) => {
     if (cellDate === obj.PersianDate) {
      result = obj.Description;
     }
    });
   }
   this.tip = result;
  } else {
   let result = '';
   if (this.datepickerService._unReservable().length !== 0) {
    const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
    this.datepickerService._unReservable().forEach((obj: any) => {
     const cellHelper = `${obj.split(',')[0].split('/')[0]}/${(
      0 + obj.split(',')[0].split('/')[1].toString()
     ).slice(-2)}/${(0 + obj.split(',')[0].split('/')[2].toString()).slice(-2)}`;
     if (cellDate === cellHelper && +obj.split(',')[1] === 2) {
      result = '1';
     }
     if (cellDate === cellHelper && +obj.split(',')[1] === 3) {
      result = '2';
     }
     if (cellDate === cellHelper && +obj.split(',')[1] === 4) {
      result = '3';
     }
    });
   }
   this.tip = result;
  }
 }

 setInitialDate() {
  if (
   this.datepickerService._startDate() &&
   this.datepickerService._endDate() &&
   this.datepickerService._allowToShow() &&
   this.datepickerPack.length !== 0
  ) {
   this.cdr.detectChanges();
   const monthArray = [
    '',
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
   ];
   const startDateArray = this.datepickerService._startDate().split('/');
   const startDateHelper = `${startDateArray[0]}/${('0' + startDateArray[1]).slice(-2)}/${(
    '0' + startDateArray[2]
   ).slice(-2)}`;
   const endDateArray = this.datepickerService._endDate().split('/');
   const endDateHelper = `${endDateArray[0]}/${('0' + endDateArray[1]).slice(-2)}/${(
    '0' + endDateArray[2]
   ).slice(-2)}`;
   this.startDate = `${startDateArray[0]}/${startDateArray[1]}/${startDateArray[2]}`;
   this.endDate = `${endDateArray[0]}/${endDateArray[1]}/${endDateArray[2]}`;
   this.customStartDate = `${this.datepickerService._startDate().split('/')[2]} ${
    monthArray[+this.datepickerService._startDate().split('/')[1]]
   }`;
   this.customEndDate = `${this.datepickerService._endDate().split('/')[2]} ${
    monthArray[+this.datepickerService._endDate().split('/')[1]]
   }`;
   this.datepickerService.setCustomStartDate(this.customStartDate);
   this.datepickerService.setCustomEndDate(this.customEndDate);
   this.cell?.toArray().forEach((obj) => {
    obj.nativeElement.classList.remove('start-date');
    obj.nativeElement.classList.remove('end-date');
    obj.nativeElement.classList.remove('duration');
   });
   this.cellInput.toArray().forEach((obj) => {
    const cellDateHelper = `${obj.nativeElement.value.split('/')[0]}/${(
     '0' + obj.nativeElement.value.split('/')[1]
    ).slice(-2)}/${('0' + obj.nativeElement.value.split('/')[2]).slice(-2)}`;
    if (startDateHelper === cellDateHelper) {
     obj.nativeElement.closest('.cell').classList.add('start-date');
    }
    if (endDateHelper === cellDateHelper) {
     obj.nativeElement.closest('.cell').classList.add('end-date');
    }
    if (startDateHelper <= cellDateHelper && endDateHelper >= cellDateHelper) {
     obj.nativeElement.closest('.cell').classList.add('duration');
    }
   });
  }
  this.setDuration();
 }

 @HostListener('document:click', ['$event']) clickout(event: any) {
  if (this.datepickerService._isMobile() === false) {
   if (!event.target.closest('.iho-datepicker')) {
    this.datepickerService.setState(false);
   }
  }
 }

 ngOnInit(): void {
  this.reservable = this.datepickerService.reservable();

  if (this.datepickerService._locale() === 'fa') {
   this.jalaliCalendar(this.initialCounter);
   this.jalaliCalendar(this.initialCounter + 1);
   this.initialCounter = 1;
  }
  if (this.datepickerService._locale() === 'en') {
   this.gregorianCalendar(this.initialCounter);
   this.gregorianCalendar(this.initialCounter + 1);
   this.initialCounter = 1;
  }
  this.setInitialDate();
 }
}
